export const Support = () => {
  return <div>Support</div>
}
